import {FormControlLabel, Switch} from "@mui/material";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";
import React from "react";
import {produce} from "immer";

const ProjectDetailSaveAsTemplatePrompt = ({
                                             showTemplateNewField,
                                             setShowTemplateNewField,
                                             draftQuoteDetail,
                                             setDraftQuoteDetail,
                                             formValidQuoteDetail
                                         }) => 
{
    const handleSaveAsNewTemplateChecked = (e) => {
        setShowTemplateNewField(e.target.checked);
        setDraftQuoteDetail(produce(draftQuoteDetail, draft => {
            draft.templateName = e.target.checked ? draft.templateName : '';
        }));
        if (e.target.checked) {
            formValidQuoteDetail.current.templateName = false;
        } else {
            delete formValidQuoteDetail.current.templateName;
        }
    }
    
    return (
        !draftQuoteDetail.templateDetails &&
        <>
            <FormControlLabel
                sx={{
                    ml: 1,
                    display: 'flex',
                    alignItems: 'center'
                }}
                control={
                    <Switch
                        checked={showTemplateNewField}
                        onChange={handleSaveAsNewTemplateChecked}
                        inputProps={{ 'aria-label': 'save-template' }}
                    />
                }
                label={
                    <Typography>Save as template</Typography>
                }
            >
            </FormControlLabel>
            <Tooltip arrow disableFocusListener title="If checked, this configuration for the selected product will be saved, and can be reused in later quotes.">
                <InfoIcon sx={{color: 'grey'}} />
            </Tooltip>
        </>
    )
}
export default ProjectDetailSaveAsTemplatePrompt;